import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import styles from "./CompletePage.module.scss";
import Header from "../Header/header";
import confetti from "canvas-confetti";

export default function CompletePage() {
  const navigate = useNavigate();

  // 🎉 Looping confetti every 2 seconds
  useEffect(() => {
    const launchConfetti = () => {
      confetti({
        particleCount: 100,
        spread: 70,
        origin: { y: 0.6 },
        colors: ["#e67e22", "#f1c40f", "#3498db", "#9b59b6", "#2ecc71"],
      });
    };

    // Run immediately once on page load
    launchConfetti();

    // Then loop every 2 seconds
    const interval = setInterval(launchConfetti, 2000);

    // Clean up when leaving page
    return () => clearInterval(interval);
  }, []);

  return (
    <div className={styles.page}>
      <Header />

      <main className={styles.main}>
        <div className={styles.content}>
          <div className={styles.illustrationWrapper}>
            <img
              src="/2.png"
              alt="You are all set"
              className={styles.illustration}
            />
          </div>

          <h1 className={styles.title}>You are all set!</h1>
          <p className={styles.subtitle}>
            Your profile setup is complete, you are now ready to get started
          </p>

          <div className={styles.actions}>
            <button
              className={styles.primaryBtn}
              onClick={() => navigate("/new-consentBundle")}
            >
              Create consent form
            </button>
            <button
              className={styles.secondaryBtn}
              onClick={() => navigate("/dashboard")}
            >
              Go to dashboard
            </button>
          </div>

          <p className={styles.note}>
            Welcome to Medicube! We are excited to help you streamline your
            dental practise
          </p>
        </div>
      </main>

      <footer className={styles.footer}>
        Copyright © Medicube 2025. All Rights Reserved.
      </footer>
    </div>
  );
}
